import { AnalyzeConstants } from '../../_constants/Analyze/analyze.constants';

const initialState = { holder_user_FitmentLoading: true, holder_user_FitmentData: {}, holder_user_FitmentError: false };

export function holder_user_FitmentReducer(state = initialState, action) {

    switch (action.type) {
        case AnalyzeConstants.REQUEST_HOLDERS_DATA:
            return {
                holder_user_FitmentLoading: true,
                holder_user_FitmentData: {},
                holder_user_FitmentError: false
            };
        case AnalyzeConstants.RECEIVE_HOLDERS_DATA:
            return {
                holder_user_FitmentLoading: false,
                holder_user_FitmentData: action.res,
                holder_user_FitmentError: false
            };
        case AnalyzeConstants.ERROR_HOLDERS_DATA:
            return {
                holder_user_FitmentLoading: false,
                holder_user_FitmentData: {},
                holder_user_FitmentError: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/Analyze/role_holder_user.reducer.js